import { PathologyItem } from '../../Enums/PathologyItem.enum';
import {
	SurfaceBasedToothWearType,
	ToothWearType,
} from '../../Components/DENTModalOverviewPathologyButtons/DENTModalOverviewPathologyToothWear';

export type ToothWearSurfacesKey = 'erosion' | 'attrition' | 'abfraction';

export const TOOTH_WEAR_SURFACES_CONFIG: Record<
	SurfaceBasedToothWearType,
	{
		pathologyItem: PathologyItem;
		key: ToothWearSurfacesKey;
		color: string;
	}
> = {
	[ToothWearType.EROSION]: {
		pathologyItem: PathologyItem.EROSION,
		key: 'erosion',
		color: '#BCBCBC',
	},
	[ToothWearType.ATTRITION]: {
		pathologyItem: PathologyItem.ATTRITION,
		key: 'attrition',
		color: '#9BC49B',
	},
	[ToothWearType.ABFRACTION]: {
		pathologyItem: PathologyItem.ABFRACTION,
		key: 'abfraction',
		color: '#9BB5D4',
	},
};
